var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8D0DF",
    d: "M5.28 2.667C2.365 2.667 0 5.056 0 8a5.327 5.327 0 002.64 4.595v17.478A5.322 5.322 0 000 34.667C0 37.609 2.365 40 5.28 40s5.28-2.39 5.28-5.333a5.316 5.316 0 00-2.64-4.594V12.595A5.322 5.322 0 0010.56 8c0-2.944-2.365-5.333-5.28-5.333zm0 34.666c-1.457 0-2.64-1.192-2.64-2.666C2.64 33.195 3.823 32 5.28 32c1.46 0 2.64 1.195 2.64 2.667 0 1.474-1.18 2.666-2.64 2.666zm0-26.666c-1.457 0-2.64-1.192-2.64-2.667 0-1.475 1.183-2.667 2.64-2.667 1.46 0 2.64 1.192 2.64 2.667 0 1.475-1.18 2.667-2.64 2.667zm23.76 19.406v-16.74c0-8.02-7.92-8-7.92-8h-2.64V0l-7.92 8 7.92 8v-5.333h2.64c2.328 0 2.64 2.666 2.64 2.666v16.74a5.316 5.316 0 00-2.64 4.594c0 2.942 2.367 5.333 5.28 5.333 2.913 0 5.28-2.39 5.28-5.333a5.32 5.32 0 00-2.64-4.594zm-2.64 7.26c-1.457 0-2.64-1.192-2.64-2.666 0-1.472 1.183-2.667 2.64-2.667 1.46 0 2.64 1.195 2.64 2.667 0 1.474-1.18 2.666-2.64 2.666z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.25a6d55d.svg";
export { ForwardRef as ReactComponent };